export class MtlError extends Error {
    constructor (readonly code: string) {
        super();
    }
}

export class LocalizedError extends Error {
    constructor (message: string, public causeMsg?: string, public params?: never) {
        super(message);
    }
}

export class UnsuccessfulRestResponse extends LocalizedError {
    constructor (readonly code: string) {
        super(`errors.mtl.status.code${code}`);
    }
}

export class XmlParserError extends Error {
    constructor (message: string) {
        super(message);
    }
}

export class MtlLocalizedError extends LocalizedError {
    constructor (readonly errorCode: number, message: string, public causeMsg?: string) {
        super(message, causeMsg);
    }
}

export class NotAuthorizedError extends Error {
}
